import { t } from "../../hooks/useAppTranslation";
import styles from "./ExternalControlStyle.module.scss";
import * as Yup from "yup";
import Input from "../Input/Input";
import SelectCustom from "../SelectCustom/SelectCustom";
import { useRef, useState } from "react";
import { ICustomSelectValues, IDictionary } from "./ExternalControlContainer";
import React from "react";
import {ISelectSearchProps} from "./ExternalControlForm";


export interface IPZPControl {
  number: string;
  type: number;
  contractNumber: string;
}
interface Props {
  pzpTypes: IDictionary[];
  pzpControls: IPZPControl[];
  setFieldValue(args: any, val: any): void;
}

export const PZPFormHelper: React.FC<Props> = ({
  pzpTypes,
  setFieldValue,
  pzpControls,
}) => {
  const [type, setType] = useState<ICustomSelectValues>();
  const [number, setNumber] = useState("");
  const [contractNumber, setContractNumber] = useState("");
  const [error, setError] = useState("");
  
  const [previousSearch, setPreviousSearch] = useState('');
  
  const selectCustomRef = useRef(null);
  
  let pzpSchema = Yup.object({
    number: Yup.string().required(t('external-controls-contract-notice-required')),
    type: Yup.string().required(t('external-controls-public-procurement-control-type-required')),
    contractNumber: Yup.string(),
  });
  return (
    <>
      <div className='row'>
        <div className='col-md-3'>
          <SelectCustom
            options={pzpTypes.map((el) => {
              return { label: el.description, value: el.entryId };
            })}
            values={
              type
                ? [
                    {
                      label: type.label,
                      value: type.value,
                    },
                  ]
                : []
            }
            onChange={(value: ICustomSelectValues[]) => {
              setType(value[0]);
            }}
            searchFn={(selectProps:ISelectSearchProps) => {
              const options = selectProps.props?.options;
              const includesOptions = options?.find((el: ICustomSelectValues) => el.label.toUpperCase().includes(selectProps.state.search.toUpperCase()));
              (includesOptions) ? setPreviousSearch(selectProps.state.search) : selectProps.state['search'] = previousSearch;
            }}
            id='ext-cnt-pzpType'
            label={t('external-controls-public-procurement-control-type')}
            placeholder={t('external-controls-public-procurement-control-type')}
            color='#0d47a1'
            containerClassName={styles.selectContainer}
            labelClassName={styles.selectCustomLabel}
            error=''
            errorId=''
            invalid=''
            labelHeader={false}
            isMulti={false}
            onClear={false}
            handle
            dropdownId=''
            disabled={false}
            parentRef={selectCustomRef}
            className=''
            optionNameVisible={undefined}
          />
        </div>
        <div className='col-md-4'>
          <Input
            inputId='ext-cnt-pzpNumber'
            label={t('external-controls-contract-notice-number')}
            placeholder={t('external-controls-contract-notice-number')}
            type='text'
            formik={true}
            maxLength={50}
            value={number}
            chartsCount={number.length}
            onChange={(e) => setNumber(e.target.value)}
          />
        </div>
        <div className='col-md-3'>
          <Input
            inputId='ext-cnt-pzpContractNumber'
            label={t('external-controls-contract-number')}
            placeholder={t('external-controls-contract-number')}
            type='text'
            maxLength={50}
            chartsCount={contractNumber.length}
            formik={true}
            value={contractNumber}
            onChange={(e) => setContractNumber(e.target.value)}
          />
        </div>
        <div className='col-md-2'>
          <button
            className={`btn save-btn ${styles.saveButton} uppercase`}
            type='button'
            onClick={async () => {
              setError("");
              const isNotUnique = pzpControls.find(
                (el: IPZPControl) => el.number === number
              );
              await pzpSchema
                .validate({ number, contractNumber, type: type?.label })
                .then(() => {
                  if (!isNotUnique) {
                    setFieldValue("pzpControls", [
                      ...pzpControls,
                      {
                        number,
                        type: type?.label,
                        typeId: type?.value,
                        contractNumber,
                      },
                    ]);
                  } else
                    setError(
                      t('external-controls-contract-notice-number-cannot-repeated')
                    );
                })
                .catch((err) => setError(err.message));
            }}
          >
            {t('g-add')}
          </button>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          {error && <p className={styles.errorMessage}>{error}</p>}
        </div>
      </div>

      {pzpControls.map((pzpControl: IPZPControl) => {
        return (
          <div key={pzpControl.number} className={styles.listSpacing}>
            <div className='row' key={pzpControl.contractNumber}>
              <div className='col-md-10'>
                <p>
                  {pzpControl.number} - {pzpControl.type}:{" "}
                  {pzpControl.contractNumber}
                </p>
              </div>
              <div className='col-md-2'>
                <button
                  className='btn cancel-btn uppercase'
                  onClick={() => {
                    const updatedValues = pzpControls.filter(
                      (el: IPZPControl) =>
                        el.contractNumber !== pzpControl.contractNumber
                    );
                    setFieldValue("pzpControls", updatedValues);
                  }}
                >
                  {t('g-delete')}
                  <span className='sr-only'>
                    {pzpControl.number} - {pzpControl.type}:{" "}
                    {pzpControl.contractNumber}
                  </span>
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};
